// extracted by mini-css-extract-plugin
module.exports = {"input":"EditName_input__ELo0E","text":"EditName_text__1iB1z"};